﻿"use strict";

import { scrollTop } from './template2/scrollTop';
import { clickHeaderPrev } from './template2/clickHeaderPrev';
import { toggleMenu } from './template2/toggleMenu';
import { changeCompany } from './template2/changeCompany';

export function init() {
    scrollTop();
    clickHeaderPrev();
    toggleMenu();
    changeCompany();
}